module.exports = __webpack_public_path__ + "22ab45c12f38aa86d820b2252eea30ee.png";